import React, { useEffect } from 'react';

import { Confirm } from 'components/ui/modal';

import { connect } from 'containers/store'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared';

import { GettyActionCreators, actionCreators } from 'domains/org/getty/actions';
import { GettyStore } from 'domains/org/getty/store';

import { DeleteVisitorTypeRequest } from 'generated/mos/org/getty/audiomanagement';
import { VisitorType } from 'generated/mos/org/getty/audio'

import { pick } from 'helpers/core'
import { Status } from 'helpers/status';

import { visitorTypeSchema } from '../../../schemas/visitor-type'

type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteVisitorTypeRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>;

type ConnectedProps = Pick<GettyStore['getty'], 'visitorTypeDelete'>;

type DirectProps = {
  readonly historyPush: (id: string) => void;
  readonly projectId: string;
  readonly visitorType: VisitorType.Entity | undefined;
  readonly onCancel: () => void;
};
type Props = ActionProps & ConnectedProps & DirectProps;

const VisitorTypeDeleteView = (props: Props) => {
  const {
    historyPush,
    projectId,
    gettyDeleteVisitorTypeRequest,
    toastNotification,
    visitorTypeDelete,
    onCancel,
    visitorType
  } = props

  const payload: DeleteVisitorTypeRequest.Entity = {
    ...DeleteVisitorTypeRequest.defaults,
    visitorTypeRef: visitorType && VisitorType.mustRef(visitorType.ref)
  }

  const visitorTypeName = visitorType && visitorTypeSchema.tag.read(visitorType.tag)

  const modalMessage = (
    <>
      <p>Are you sure you want to permanently delete "{visitorTypeName}"?</p>
    </>
  )

  const onConfirmDelete = () => {
    gettyDeleteVisitorTypeRequest(payload)
    historyPush(`/project/${projectId}/moods`)
  }

  useEffect(() => {
    if (visitorTypeDelete.status === Status.Failed) {
      toastNotification({
        type: 'error',
        text: 'Could not delete visitor type',
      });
    }
  }, [visitorTypeDelete.status]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Confirm
      title="Delete visitor type?"
      onClose={onCancel}
      message={modalMessage}
      confirmLabel="Delete"
      onConfirm={onConfirmDelete}
      danger
    />
  );
};

export const VisitorTypeDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => pick(store.getty, 'visitorTypeDelete'),
  {
    ...pick(actionCreators, 'gettyDeleteVisitorTypeRequest'),
    ...pick(sharedActionCreators, 'toastNotification')
  }
)(VisitorTypeDeleteView)
